<template>
  <div v-loading.fullscreen.lock="loading" class="address_new">
    <!-- 头部 -->
    <header-bar :rightPart="true" @backTo="backTo">
      <template slot="difinePort">
          <div class="address_top_right" v-if="editId">
            <span @click="delFn">删除</span>
          </div>
      </template>
    </header-bar>
    <!-- 头部 结束 -->
    <van-cell-group class="user_list ctn_top">
      <van-field v-model="receiverName" label="联系人" placeholder="请填写联系人姓名" />
      <van-field v-model="receiverPhone" label="手机号" placeholder="请填写联系人手机号" />
      <div class="user_address_all">
        <span class="left_text">所在地区</span>
        <div class="user_address" @click="showAddressPicker">
          <div>
            <img src="@/images/locaiton.png" alt="">
            <span>{{areaAll}}</span>
          </div>
          <img src="@/images/icon_right.png" alt="">
        </div>
      </div>
      <van-field v-model="address" label="详细地址" placeholder="如：道路、门牌号、小区、楼栋号等" />
    </van-cell-group>
    <div class="user_flex">
      <span>设为默认地址</span>
      <van-switch v-model="idDefault" active-color="#29BEBC" inactive-color="#CCC" size="24px" />
    </div>
    <div class="btn_address" @click='saveAddress'>保存地址</div>
    <van-popup
      :lock-scroll="true"
      v-model="addressShow"
      closeable
      round 
      position="bottom"
      :style="{ height: '84%' }"
    >
    <div class="pop_address">
        <div class="pop_title">
          <div class="pop_tips">请选择所在地区</div>
          <van-tabs v-model="currentTab" @click="tabClick">
            <van-tab :title="item.label" v-for="(item,index) in checkedAddress" :key="index"></van-tab>
          </van-tabs>
        </div>
        <div class="address_data">
            <div v-for="item in addressData" 
            :key="item.id"
            @click="cityClick(item)"
            >{{item.areaName}}</div>
        </div>
    </div>
    </van-popup>
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from "vue";
import headerBar from "../../components/headerBar";
import { toast } from "@/common/api/api.js";
export default {
  components: {
    headerBar
  },
  data() {
    return {
      getDataConfig:[//配置数组
          {
            value:"provinceId",//后端要的key
            index:0,//取对应数组的索引
            key:"value",//取对应数组的key
          },
           {
            value:"provinceName",
            index:0,
            key:"label",
          },
           {
            value:"cityId",
            index:1,
            key:"value",
          },
           {
            value:"cityName",
            index:1,
            key:"label",
          },
           {
            value:"areaId",
            index:2,
            key:"value",
          },
           {
            value:"areaName",
            index:2,
            key:"label",
          },
      ],
      loading:false,
      idDefault:false,
      addressShow:false,
      currentTab:0,
      addressData:[],
      parentCode:'',
      areaType:1,
      checkedAddress:[{label:'请选择'}],
      receiverName:'',//联系人
      receiverPhone:'',//手机号
      address:'',//详细地址
      currentBaseInfo: JSON.parse(localStorage.getItem("loginInfo")),
      areaAll:'请选择所在地区',
      editId:'',
      originData:{},//编辑初始数据
      category:''
    };
  },
  mounted(){
    this.getAddressList();
    const {id,welfareCategory} = this.$route.query;
    this.category = welfareCategory
    this.editId=id;
    if(id)this.queryFn(id);
  },
  methods:{
    // 返回方法
    backTo(){
      if(this.editId){
        // 编辑的时候返回判断是否有修改
        let {provinceId,cityId,areaId,receiverName,receiverPhone,address,defaultAddress} = this.originData;
        defaultAddress=defaultAddress==1?true:false;
        let provinceIdNew = this.checkedAddress[0].value;
        let cityIdNew = this.checkedAddress[1].value;
        let areaIdNew = this.checkedAddress[2].value;
        if(receiverName!=this.receiverName||receiverPhone!=this.receiverPhone||address!=this.address||
        provinceIdNew!=provinceId||cityId!=cityIdNew||areaIdNew!=areaId||defaultAddress!=this.idDefault){
          this.dialogFnConfirm('信息还未保存，确认返回吗？')
          return;
        }
        this.$router.go(-1);
      } else {
        // 新增的时候返回判断是否有输入
        if(this.checkedAddress[0].label!='请选择'||this.receiverName||this.receiverPhone||this.address){
          this.dialogFnConfirm('信息还未保存，确认返回吗？')
          return;
        }
        this.$router.go(-1);
      }    
    },
    // 修改title
    updateTitleFn(){
      this.centralControl.utils.updateDocumentTitle('编辑配送地址')
    },
    // 处理查询数据
    queryDataTransform(res){
      let data = res.data&&res.data.length&&res.data[0];
      this.originData=JSON.parse(JSON.stringify(data));
      const {provinceName,provinceId,cityName,cityId,areaName,areaId,receiverName,receiverPhone,address,defaultAddress} = data;
      this.checkedAddress=[
        {label:provinceName,value:provinceId},
        {label:cityName,value:cityId},
        {label:areaName,value:areaId},
      ]
      this.areaAll=this.getAreaAll(); 
      this.receiverName=receiverName;
      this.receiverPhone=receiverPhone;
      this.address=address;
      this.idDefault=defaultAddress==1?true:false;//默认地址
      this.currentTab=2;
      this.areaType=3;
      this.parentCode=cityId;
      this.getAddressList();
    },
    // 查询详情
    queryFn(id){
      this.updateTitleFn();
      let params = {
        staffId:this.currentBaseInfo.id,
        id,
        welfareCategory:this.category
      }
      this.centralControl.axios.centralControl(
          "getAddressByStaff",
          res => {
            this.loading=false;
            if (res.code == 200) {
              this.queryDataTransform(res);
            } else {
              toast(this, res.message);
            }
          },
          params
        );
    },
    // 处理选择的地址
    getAreaAll(){
      return this.checkedAddress.map(function(obj,index){
            return obj.label;
        }).join(" ");
    },
    // 省市区点击
    cityClick(item){
      this.areaType=parseInt(item.areaType)+1;
      this.checkedAddress[this.checkedAddress.length-1].label=item.areaName;
      this.checkedAddress[this.checkedAddress.length-1].value=item.areaCode;
      this.currentTab=this.checkedAddress.length-1;
      // if(this.currentTab==2){
      //   this.areaAll=this.getAreaAll();
      // }
      this.areaAll=this.getAreaAll();
      if(this.areaType==4)return this.addressShow=false;
      this.checkedAddress.push({label:'请选择'})
      this.parentCode=item.areaCode;
      this.getAddressList();
    },
    //点击省市区tab
    tabClick(e){
      this.checkedAddress=this.checkedAddress.slice(0,e+1);
      this.areaType=e+1;
      if(this.areaType==1){
        this.parentCode='';
      } else {
        this.parentCode=this.checkedAddress[this.checkedAddress.length-2].value;
      }
      this.getAddressList();
      this.areaAll=this.getAreaAll();
    },
    // 获取省市区
    getAddressList(){
      let params = {
        areaType:this.areaType,
        parentCode:this.parentCode
      }
      this.centralControl.axios.centralControl(
        "getCityList",
        res => {
          if (res.code == 200) {
            this.addressData=res.data;
          } else {
            toast(this, res.message);
          }
        },
        params
      );
      
    },
    // 打开省市区弹框
    showAddressPicker() {
      this.addressShow=true;
    },
    // 获取保存地址参数
    saveAddressGetdata(){
      const {receiverName, receiverPhone, address} = this;
      const {id,welfareCategory} = this.$route.query;      
      let params = {
        receiverName, receiverPhone, address,
        staffId:this.currentBaseInfo.id,
        welfareCategory:welfareCategory
      }
      if(this.checkedAddress&&this.checkedAddress.length){
        var arrConfig = this.getDataConfig;
        arrConfig.forEach((item,index)=>{
          params[item.value] = this.checkedAddress[item.index][item.key]
        })
      }//省市区转换
      if(id)params.id=id;//编辑
      if(this.idDefault)params.defaultAddress=1;//默认地址
      return params;
    },
    // 校验
    testParams(){
      const {receiverName, receiverPhone, address} = this;
      let nameReg = new RegExp(/[@#\$%\^&\*]+/g);
      let phoneReg = new RegExp(/^[1][3,4,5,7,8,9][0-9]{9}$/);
      if(nameReg.test(receiverName)||receiverName.length<2){
        this.dialogFn('收货人姓名长度需在2-25个字符之间不能包含非法字符')
        return;
      }
      if (!phoneReg.test(receiverPhone)) {
        this.dialogFn('请输入正确手机号')
        return;
      }
      if(this.checkedAddress.length!=3||this.checkedAddress[this.checkedAddress.length-1].label=='请选择') {
        this.dialogFn('请选择完整的行政区划信息')
        return;
      }
      return true;
    },
    dialogFnConfirm(tip){
        this.$createDialog({
        type: "confirm",
        title: "提示",
        content: tip,
        confirmBtn: {
          text: "确定",
          active: true,
          href: "javascript:;"
        },
        cancelBtn: {
          text: "取消",
          active: false,
          href: "javascript:;"
        },
        onConfirm: () => {
         this.$router.go(-1);
        }
      }).show();
    },
    dialogFn(tip){
      this.$createDialog({
          type: 'alert',
          title: '提示',
          content:tip,
        }).show()
    },
    // 保存地址
    saveAddress(){
      if(!this.testParams())return;
      let params=this.saveAddressGetdata();
      this.centralControl.axios.centralControl(
        "addOrUpdateAddress",
        res => {
          if (res.code == 200) {
            toast(this, res.message,'success');
            this.$router.go(-1);
          } else {
            toast(this, res.message,"error");
          }
        },
        params
      );
    },
    // 删除地址
    delFn(){
      const {id,welfareCategory} = this.$route.query;
      this.$createDialog({
        type: "confirm",
        title: "提示",
        content: `请确认是否删除该地址?`,
        onConfirm: () => {
          this.centralControl.axios.centralControl(
            "delAddress",
            res => {
              if (res.code == 200) {
                toast(this, res.message,'success');
                this.$router.go(-1);
              } else {
                toast(this, res.message);
              }
            },
            {id,welfareCategory}
          );
        }
      }).show();   
    },
  }
}
</script>
<style lang="stylus" type="stylesheet/stylus">
@import "../../assets/stylus/common"
  .address_new{
    .top-box {
      justify-content: space-between;
    }
    .address_top_right {
      margin-right: 16px;
      font-size: 14px;
    }
    .user_list {
      background: #FFF;
      >div {
        display: flex;
        padding: 16px;
        // border-bottom: 1px solid #EFEFF4;
        align-items: center;
      }
      .user_address_all {
        padding: 14px 16px;
        position relative
        // border-bottom: 1px solid #EFEFF4;
      }
      .user_address_all::after {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        right: 0;
        bottom: 0;
        left: 0;
        border-bottom: 1px solid #ebedf0;
        transform: scaleY(.5);
      }
     
      .left_text, .van-field__label {
        display: inline-block;
        width: 78px;
        font-size:14px;
        font-family:PingFang SC;
        // font-weight:500;
        color:rgba(51,51,51,1);
      }
      .user_address,.van-field__value input{
          font-size:14px;
          font-family:PingFang SC;
          font-weight:500;
          color:rgba(136,136,136,1);
      }
      >div:last-child{
        border:none;
      }
      .user_address {
         margin-left: 18px;
         width: 100%;
         display: flex;
         justify-content: space-between;
         align-items: center;
         >div {
            display: flex;
            align-items: center;
            img {
              width: 12px;
              margin-right: 4px;
            }
         }
         >img {
           width: 28px;
           height: 26px;
         }
      }
    }
    .user_flex {
      display: flex;
      align-items: center;
      background: #FFF;
      margin-top: 10px;
      justify-content: space-between;
      padding: 12px 16px;
      >span {
        font-size:14px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(51,51,51,1);
      }
    }
    .btn_address {
        margin: 20px 16px;
        background:rgba(41,190,188,1);
        border-radius:5px;
        font-size:18px;
        font-family:PingFangSC-Semibold,PingFang SC;
        color:rgba(255,255,255,1);
        line-height:44px;
        text-align: center;
        height: 44px;
    }
    .cube-dialog-content{
      text-align: center !important;
    }
    // 地址弹框
    .pop_address {
      display: flex;
      flex-direction: column;
      height:100%;
      position:relative;
      .pop_title {
        flex: 1;
        .pop_tips {
          font-size:15px;
          font-family:PingFang SC;
          font-weight:500;
          color:rgba(136,136,136,1);
          margin-bottom: 10px;
          padding: 16px;
        }
      }
    }
    .address_data {
      overflow-y: auto;
      // height: 400px;
      height: 80%;
      flex: 3;
      position:absolute;
      width:100%;
      top:100px;
      >div {
        height:49px;
        line-height: 49px;
        padding-left: 16px;
        font-size:14px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(136,136,136,1);
      }

      >div:nth-child(2n){
        background:rgba(252,252,252,1);
      }
      >div:nth-child(2n+1){
        background:rgba(255,255,255,1);
      }
    }

    .van-tabs__nav--line {
      width: 210px;
    }
    .van-tabs {
      width: 100%;
      border-bottom: 1px solid #E5E5E5;
    }
    .van-popup--bottom.van-popup--round{
      border-radius: 6px 6px 0 0;
    }
    .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
      border:none;
    }
    .van-cell::after {
      left:0
    }
    .van-tab{
      flex:none;
      margin-left:10px;
    }
    .van-popup{
      overflow-y:hidden;
    }
  }
</style>